import { useEffect, useMemo } from "react";

const collapseSpaces = (str) => String(str || "").replace(/\s+/g, " ").trim();

export default function useCorresponsalesProcedimientos({
  concSlice,
  search,
  statusFilter,
  currentPage,
  pageSize,
  setCurrentPage,
}) {
  const corresponsalesItems = useMemo(() => {
    const raw = concSlice?.data;
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.items)) return raw.items;
    return [];
  }, [concSlice]);

  const normalize = (v) => collapseSpaces(v).toLowerCase();

  const searchedCorresponsales = useMemo(() => {
    const term = normalize(search);
    if (!term) return corresponsalesItems;
    return corresponsalesItems.filter((c) => {
      const campos = [c?.nombre, c?.correo, c?.celular, c?.id_corresponsal];
      return campos.some((v) => normalize(v).includes(term));
    });
  }, [search, corresponsalesItems]);

  const filteredCorresponsales = useMemo(() => {
    let list = [...searchedCorresponsales];
    if (statusFilter && statusFilter !== "todos") {
      list = list.filter((c) => {
        const isActive = Number(c?.active) === 1;
        if (statusFilter === "activos") return isActive;
        if (statusFilter === "inactivos") return !isActive;
        if (statusFilter === "nuevos") {
          const d = c?.datetime ? new Date(c.datetime) : null;
          if (!d || Number.isNaN(d.getTime())) return false;
          return (Date.now() - d.getTime()) / 86400000 <= 30;
        }
        return true;
      });
    }
    return list;
  }, [searchedCorresponsales, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, statusFilter, setCurrentPage]);

  const paginatedCorresponsales = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredCorresponsales.slice(start, start + pageSize);
  }, [filteredCorresponsales, currentPage, pageSize]);

  return {
    filteredExpedientes: filteredCorresponsales,
    paginatedExpedientes: paginatedCorresponsales,
    totalExp: filteredCorresponsales.length,
  };
}
